"use strict";
/**
 * @fileoverview API query parameters interface for searching customers
 * Defines pagination and search term parameters
 */
Object.defineProperty(exports, "__esModule", { value: true });
